import { useSelector } from "react-redux";
import { useMemo, useEffect } from "react";
import isEmpty from "lodash/isEmpty";

import useFetchMenu from "@hooks/menu/use-menu-fetch";
import useFetchTotalBaseProductCount from "@stadium/hooks/lib/priceless/use-fetch-total-base-product-count";

import {
  getCommonElasticSearchStoreVariables,
  getStoreCloneId,
  getStoreID,
  getStoreNumber,
  getStoreParentId,
  getStoreSyncedToES,
} from "@selectors/store";
import { getAllMenuTaxons } from "@helpers/menu";

import { DEFAULT_COUNTRY_ISO } from "@stadium/constants";

const useFetchPriclessShopTotalBaseProductCount = () => {
  const storeNumber = useSelector(getStoreNumber) || "";
  const storeParentId = useSelector(getStoreParentId);
  const storeId = useSelector(getStoreID);
  const syncedToEs = useSelector(getStoreSyncedToES);
  const storeCloneId = useSelector(getStoreCloneId);
  const commonESVariables = useSelector(getCommonElasticSearchStoreVariables);
  const {
    loading: menuLoading,
    menuData,
    fetchMenuData,
  } = useFetchMenu({
    skip: !storeNumber,
    additionalVariables: {
      isGlobalCountry: false,
      country: DEFAULT_COUNTRY_ISO,
      menuItemsCountry: DEFAULT_COUNTRY_ISO,
    },
    noPriceRangeRestriction: true,
  });

  useEffect(() => {
    if (storeNumber) {
      fetchMenuData();
    }
  }, [storeNumber]);

  const { allMenuTaxonIds, anyMenuWithSwag } = useMemo(() => {
    const { allChildren } = menuData;
    if (!menuLoading && !isEmpty(menuData)) {
      return getAllMenuTaxons(allChildren);
    }

    return {
      allMenuTaxonIds: [],
      anyMenuWithSwag: false,
    };
  }, [menuData, menuLoading]);

  return useFetchTotalBaseProductCount({
    storeParentId,
    storeId,
    commonShopVariables: commonESVariables,
    syncedToEs,
    storeCloneId,
    allMenuTaxonIds,
    anyMenuWithSwag,
  });
};

export default useFetchPriclessShopTotalBaseProductCount;
